import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Globe2, Newspaper, Images, MessageSquareQuote, Users, Handshake, Inbox } from "lucide-react";
import { api } from "../lib/api";

const cards = [
  ["packages", "Packages", Package], ["tours", "Halal Tours", Globe2], ["blogs", "Blog Posts", Newspaper], ["gallery", "Gallery Photos", Images],
  ["testimonials", "Testimonials", MessageSquareQuote], ["team", "Team Members", Users], ["partners", "Partners", Handshake],
];

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div><h1 className="text-3xl font-bold text-jannah-ink">{title}</h1>{sub && <p className="mt-1 text-sm text-jannah-ink/60">{sub}</p>}</div>
    {children}
  </div>
);

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div data-testid="admin-dashboard">
      <PageTitle title="Dashboard" sub="Overview of your website content and new inquiries." />
      <Link to="/admin/inquiries" className="block rounded-2xl bg-jannah-green text-white p-6 mb-6 hover:bg-jannah-green-dark transition-colors" data-testid="dashboard-inquiries-card">
        <div className="flex items-center gap-4"><Inbox size={30} className="text-jannah-gold-light" /><div><div className="text-4xl font-bold">{data.counts.new_inquiries}</div><div className="text-sm text-white/80">new inquiries · {data.counts.inquiries} total</div></div></div>
      </Link>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(([k, label, Icon]) => (
          <Link key={k} to={`/admin/c/${k}`} className="rounded-2xl bg-white border border-jannah-sand p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all" data-testid={`dashboard-card-${k}`}>
            <Icon size={22} className="text-jannah-green" />
            <div className="mt-3 text-3xl font-bold text-jannah-ink">{data.counts[k]}</div>
            <div className="text-sm text-jannah-ink/60">{label}</div>
          </Link>
        ))}
      </div>
      <h2 className="mt-10 mb-4 text-xl font-bold text-jannah-ink">Recent inquiries</h2>
      <div className="rounded-2xl bg-white border border-jannah-sand divide-y divide-jannah-sand">
        {data.recent.length === 0 && <div className="p-6 text-sm text-jannah-ink/50">No inquiries yet.</div>}
        {data.recent.map((q) => (
          <div key={q.id} className="p-4 flex items-center justify-between gap-4 text-sm">
            <div><span className="px-2 py-0.5 rounded bg-jannah-green/10 text-jannah-green text-xs font-bold uppercase mr-2">{q.type}</span>{q.data?.name || q.data?.email}</div>
            <div className="text-xs text-jannah-ink/50">{new Date(q.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
